export const categoriesAndProperties = {
  properties: "Properties",
  addProperty: "Add Property",
  addCategory: "Add Category",
  addSubCategory: "Add Sub Category",
  addExtraCategory: "Add Extra Category",
  category: "Category",
  subCategory: "Sub-category",
  subCategories: "Sub-categories",
  extraCategory: "Extra-category",
  extraCategories: "Extra-categories",
  selectProperty: "Select Property",
  isNumerical: "Is Numerical",
  value: "Value",
  uom: "UOM",
  selectCategory: "Select Category",
  categoriesJsonImport: "Import categories from a JSON file",
  categoriesJsonChooseFile: "Choose JSON file",
  categoriesJsonNoFile: "No file selected",
  categoriesJsonEmptyFile: "Choose a JSON file to import.",
  categoriesJsonInvalid: "Could not read or parse the JSON file.",
  categoriesJsonBadStructure:
    'JSON must be an array of objects with a "name" and optional "children" array, or { "categories": [...] }.',
  categoriesImportDone: "Imported {{count}} categories.",
  categoriesImportFailed: "Category import failed.",
  categoriesDeleteAll: "Delete all categories",
  categoriesDeleteAllConfirm:
    "This will permanently remove every category, subcategory, and extra-category. This cannot be undone.",
  categoriesDeleteAllDone: "Deleted {{count}} categories.",
  categoriesDeleteAllEmpty: "There are no categories to delete.",
  categoriesDeleteAllFailed: "Could not delete all categories.",
  categoriesRateLimited:
    "The server rate-limited category requests. Wait a moment and try again.",
  propertiesJsonImport: "Upload additional properties schema",
  propertiesJsonChooseFile: "Choose JSON file",
  propertiesJsonNoFile: "No file selected",
  propertiesJsonEmptyFile: "Choose a JSON schema file to upload.",
  propertiesJsonInvalid: "Could not read or parse the JSON file.",
  propertiesJsonBadStructure:
    'JSON must be a JSON array of objects, or exactly { "additionalParameters": [ ... ] }. Each object must have only these keys: key, label, dataType, required, defaultValue, validationRule, class, group. Each value may be null (use null or a string, boolean, or number where applicable). If validationRule is a non-empty string, it must be a valid JavaScript RegExp pattern. class must be null or a non-empty string (universal when null). group is frontend-only: null keeps the field on the Properties tab; a non-empty string creates a separate tab named after the group.',
  propertiesJsonStrictErrorRoot:
    'JSON must be an array, or a single-property object { "additionalParameters": [...] }.',
  propertiesJsonStrictErrorRowNotObject: "Row {{index}} must be a JSON object.",
  propertiesJsonStrictErrorUnknownKey:
    'Row {{index}} has unknown property "{{prop}}". Allowed keys: key, label, dataType, required, defaultValue, validationRule, class, group.',
  propertiesJsonStrictErrorMissingKey:
    'Row {{index}} is missing required property "{{prop}}".',
  propertiesJsonStrictErrorKey: "Row {{index}}: key must be a string or null.",
  propertiesJsonStrictErrorLabel:
    "Row {{index}}: label must be a string or null.",
  propertiesJsonStrictErrorDataType:
    "Row {{index}}: dataType must be a string or null.",
  propertiesJsonStrictErrorRequired:
    "Row {{index}}: required must be a boolean or null.",
  propertiesJsonStrictErrorDefaultValue:
    "Row {{index}}: defaultValue must be a string, number, boolean, or null.",
  propertiesJsonStrictErrorValidationRule:
    "Row {{index}}: validationRule must be a string or null.",
  propertiesJsonStrictErrorRegex:
    "Row {{index}}: validationRule is not a valid regular expression.",
  propertiesJsonStrictErrorClass:
    "Row {{index}}: class must be null or a non-empty string.",
  propertiesJsonStrictErrorGroup:
    "Row {{index}}: group must be null or a non-empty string.",
  propertiesTableClass: "class",
  propertiesTableGroup: "group",
  propertiesImportDone: "Imported {{count}} properties.",
  propertiesImportDonePartial:
    "Imported {{created}} properties; {{skipped}} row(s) skipped (no non-empty key).",
  propertiesImportNoneCreated:
    "No properties were imported. Each catalog row needs a non-empty key string.",
  propertiesSchemaUploadDone:
    "Additional properties schema saved as {{fileName}}.",
  propertiesSchemaUploadFailed: "Additional properties schema upload failed.",
  propertiesSchemaLoadError:
    "Could not load the saved additional properties schema. Try again or contact support.",
  propertiesSavedSchemaRibbonFallback: "Current saved schema",
  propertiesSavedSchemaActiveFileHint: "Schema saved on server",
  propertiesImportFailed: "Property import failed.",
  propertiesImportPreviewHeading: "Import preview",
  propertiesImportPreviewSub:
    "Review the parameters parsed from your selected file. Use Submit below to save this as the current additional properties schema.",
  propertiesSavedHeading: "Saved in catalog",
  propertiesSubmittedSchemaHeading: "Submitted schema",
  propertiesSubmittedSchemaSub:
    "This is the schema stored on the server for the marketplace. To replace it, upload a new JSON file.",
  propertiesEmptyCatalog: "No attributes are stored in the catalog yet.",
  propertiesFieldKey: "Key",
  propertiesBadgeRequired: "Required",
  propertiesBadgeOptional: "Optional",
  propertiesNoValidationRule: "No pattern",
  propertiesFieldDefault: "Default",
  propertiesFieldValidation: "Validation pattern",
  propertiesTableIndex: "#",
  propertiesTableFieldId: "Field identifier",
  propertiesTableDisplayName: "Display name",
  propertiesTableKeyHeader: "key",
  propertiesTableLabelHeader: "label",
  propertiesTableDataType: "dataType",
  propertiesTableRequired: "required",
  propertiesTableDefaultValue: "defaultValue",
  propertiesTableValidationPattern: "Validation pattern",
  propertiesTableValidationRule: "validationRule",
  propertiesTableOtherFields: "Other fields",
  propertiesTableYes: "Yes",
  propertiesTableNo: "No",
  propertiesTableNotApplicable: "—",
  propertiesTableNotSet: "Not set",
  propertiesTableNone: "None",
  // ===============================================================
};
